export const validateRules = (rules, value) =>
  rules.reduce((acc, rule) => {
    if (acc) {
      return acc;
    }
    return rule(value)?.errorMessage;
  }, "");

export const validateFields = (fieldRefs) => {
  const { isValid, scrollIntoView } = Object.values(fieldRefs)
    .reverse()
    .reduce(
      (acc, currRef) => {
        const err = !!currRef.current?.validate?.();
        if (!acc.isValid || !err) {
          return acc;
        }
        return {
          isValid: !err,
          scrollIntoView: currRef.current.scrollIntoView,
        };
      },
      {
        isValid: true,
      }
    );

  if (!isValid) {
    scrollIntoView?.();
  }

  return isValid;
};
